/**
 * The repair sweep's target vocabulary, kept in a dependency-free module so
 * both the sweep contract (`reconciliation-repair`) and the persisted command
 * payload (`payloads`) can build their enums from the same list without an
 * import cycle. They previously hand-duplicated these values and drifted.
 */

export const RepairTargetTypeList = [
  "broad_scan",
  "stale_queued",
  "stale_dispatching",
  "stale_waiting",
  "failed_retryable",
  "bridge_mutation_receipt",
] as const;

export type RepairTargetType = (typeof RepairTargetTypeList)[number];

/**
 * Converging a bridge mutation receipt moves real provider money, so it is
 * reachable only by naming the exact owner Command and receipt. A broad scan may
 * report an unresolved receipt but must never converge one it merely found.
 */
export const BRIDGE_MUTATION_RECEIPT_REPAIR_TARGET =
  "bridge_mutation_receipt" as const;

export const RepairSweepStaleStatusList = [
  "queued",
  "dispatching",
  "waiting_on_webhook",
  "waiting_on_shopify",
  "failed_retryable",
] as const;

export type RepairSweepStaleStatus =
  (typeof RepairSweepStaleStatusList)[number];
